
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/outlet/bakers-confectioners",
      function () {
        return require("private-next-pages/outlet/bakers-confectioners.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/outlet/bakers-confectioners"])
      });
    }
  